import get from 'lodash.get';

export const selectMaintenance = (state) => {
  return get(state, 'maintenance', null);
};
